module.exports = __webpack_public_path__ + "img/tiktok.ac0c927.png";